export const BASE_API_TIMEOUT = 24000
const SHORT_TIMEOUT_COEFFICIENT = 1.25
const LONG_TIMEOUT_COEFFICIENT = 3
const VERY_LONG_TIMEOUT_COEFFICIENT = 10
const EXTRA_LONG_TIMEOUT_COEFFICIENT = 30

export const SHORT_API_TIMEOUT = BASE_API_TIMEOUT * SHORT_TIMEOUT_COEFFICIENT
export const LONG_API_TIMEOUT = BASE_API_TIMEOUT * LONG_TIMEOUT_COEFFICIENT
export const VERY_LONG_API_TIMEOUT = BASE_API_TIMEOUT * VERY_LONG_TIMEOUT_COEFFICIENT
export const EXTRA_LONG_API_TIMEOUT = BASE_API_TIMEOUT * EXTRA_LONG_TIMEOUT_COEFFICIENT
